import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { initiallizeApi } from './api';

import signals from './common/signals';
import * as storage from './common/storage';
import logger from './logger';
import { expose, getTarget } from './rpc';
import { useLayoutStore } from './store/layout';
import { useThemeStore } from './store/theme';
import { useWidgetStore } from './store/widget';
import { useMoinBot } from './services/bot/botv2.js';
import { getPrimusUrl } from './common/utils.js';
import { useTeaserStore } from './store/teaser';
import { getConfig } from './services/configurations';





const initWidget = async () => {
  try {


    const _mount = document.getElementById('moinai-container');
    const _botId = document.body.getAttribute('data-bot');
    const _channelId = document.body.getAttribute('data-channel') || undefined;


    if (!_mount) throw new Error('no mount point found');
    if (!_botId) throw new Error('no botId found');

    // fetch config asap
    const config = await getConfig(_botId, _channelId);;

    // persist if access to localStroage is allowed
    storage.setIsPersitenaceAllowed(config.useLocalStorage);

    const app = createApp(App);
    const pinia = createPinia()
    app.use(pinia);

    // make sure is ready to connect in case we have restore previous in the config
    const bot = useMoinBot();
    bot.setConfig(config, getPrimusUrl());

    const widgetStore = useWidgetStore();
    const themeStore = useThemeStore();
    const teaserStore = useTeaserStore();
    const layoutStore = useLayoutStore();



    layoutStore.initializeFromConfig(config);
    widgetStore.setConfig({ ...config });
    themeStore.setConfig(config);


    // after the bot prepared, we can initialize the widget
    widgetStore.initializeFromConfig(config);

    // this happens after the widget the config is processed
    // script tag attributes have the higher priority
    // and therefore overwrite the config if there are conflicts
    const scripttag = window.parent.document.getElementById('moinloader');
    if (!scripttag) throw new Error('no script tag found');
    if (scripttag?.dataset) {
      const attrs = Object.keys(scripttag?.dataset)
      widgetStore.initializeFromScriptTagAttributes(attrs)
    }

    initiallizeApi();
    app.mount(_mount);


    // move the teaser initialization to here due a timing / loading issue
    // set the teaser from the config if we got one
    teaserStore.initializeFromConfig(config);

    // also check the api for a teaser
    // this will be done in the background and we don't await it
    // it will overwrite the teaser from the config if there is one
    // https://github.com/knowhereto/moin-widget/issues/44
    teaserStore.fetchRemoteTeaserFromAPI(config.botId, config.channelId)
    // done mounting, call host script widget ready
    logger.log('init:done');
    const pargetWindowRPC = getTarget({ target: window.parent });
    pargetWindowRPC.call('widgetIsReady', { botId: config.botId, channelId: config.channelId });

    // queue microtask to make sure widgetReady function is called first
    setTimeout(() => {
      // send signals to customer handlers that the widget is ready and mounted
      signals.lifecycle('widget', { event: 'widget:ready' });
      signals.lifecycle('widget', { event: 'mounted' });
    }, 0);

    // expose the unmount function to the parent window
    const unmount = () => {
      bot.end();
      app.unmount();
      // TODO REMOVE RPC?
    };

    // expose callable unmount function to deconstuct the widget
    expose('unmount', unmount);


  } catch (error) {
    logger.error('error initializing the widget', error);

  }
};

initWidget();
